// extracted by mini-css-extract-plugin
module.exports = {"NewAreaInput":"NewArea_NewAreaInput__KL5Uo","NewAreaLoader":"NewArea_NewAreaLoader__21IPz","NewAreaReserveCheckbox":"NewArea_NewAreaReserveCheckbox__Zc_oz"};